import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import UstaGiris from './pages/UstaGiris';
import UstaPanel from './pages/UstaPanel';

export default function App() {
  useEffect(() => {
    const link = document.querySelector('#pwa-manifest');
    if (link) {
      link.href = '/manifest-usta.json';
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Usta Giriş Sayfası */}
        <Route path="/giris" element={<UstaGiris />} />

        {/* Usta Paneli */}
        <Route path="/panel" element={<UstaPanel />} />

        {/* Redirects - giriş sayfasına yönlendir */}
        <Route path="/" element={<Navigate to="/giris" replace />} />
        <Route path="*" element={<Navigate to="/giris" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
